<template>
  <div class="hello">
    <div class="subTitle">铜仁万山天立学校</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'trwstlxx',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM7tzuZ/kW5fxLWYwbeL+1iTxvrBTpD+Gk1raohexY0WN6TVxeeR6H5Qxq8nwN6M18stdbSWpfwwRp/+OVPdJkKDO/RCeYzhJK0cGLmp5/cCgaCOnOFxdPeVTE8Icj3t4zfvPhpGszI2+9NkIRCBCVAc='
        },
        {
          label: '素养服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMwek0JYYIVO/mhRye86FxX1oeKTHrRztFi9CQfwro0N+wfgz7cwyAKDIiWTHtw5GHEn0Q6N8zlCa8SOkzHWV6wuLBiw2si9FePMQCQ6sUpfwh118sRcfOWR7rmaXuVU6o2IP6Qk8yDbtCil6bSYJDZEzQHioxNWLkU45PhMOlgkW'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM6bzy/oizJGBNPMUiEBtGzufyGfO1PplN6gkIH5lgsNUDkguYMXBA/RNGJ2EPz2rAbHZ/Db/9ORcRmm52FrjDbMwRhJ86KYb7j0jflf7WW/0vpLay5dTTQojuTRfVi8Dl4eWQn+v7azMBsoasVitPjg='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '铜仁万山天立学校';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

